module.exports = __webpack_public_path__ + "img/b7d7c2a.jpg";